module.exports = __webpack_public_path__ + "img/car.394c3e76.png";